import React from 'react';
import Link from 'next/link';
import { cn } from '@/utils/cn';
import ButtonLabel from '../Typography/ButtonLabel';

function OutlineButtonV2({
  as = 'button', // Default to "button"
  href = '#', // Default to "#" for Link
  label = '', // Text label inside the button
  children, // For nested content
  disabled = false,
  className = '',
  ...rest
}) {
  const buttonClasses = cn(
    'w-full max-w-[135px] lg:max-w-[300px] h-[36px] rounded-[100px] flex justify-center items-center px-16 py-8 transition-all duration-300 border bg-transparent border-coarse-wool',
    className,
    {
      'cursor-not-allowed bg-aquarelle-purple border-himalayan-poppy': disabled,
    },
  );

  const labelClasses = cn(
    'text-sm text-tealgreen font-bold capitalize line-clamp-1',
    {
      'text-atelier': disabled,
    },
  );

  return as === 'a' ? (
    <Link
      prefetch={false}
      href={href}
      className={buttonClasses}
      aria-label="Go to outline button"
      {...rest}
    >
      {label ? (
        <ButtonLabel label={label} className={labelClasses} />
      ) : (
        children
      )}
    </Link>
  ) : (
    <button
      type="button"
      className={buttonClasses}
      disabled={disabled}
      {...rest}
    >
      {label ? (
        <ButtonLabel label={label} className={labelClasses} />
      ) : (
        children
      )}
    </button>
  );
}

export default OutlineButtonV2;
